import React from 'react'
import Navbar from '../global-components/navbar'
import PageHeader from '../global-components/page-header'
import Footer from '../global-components/footer'
import useFetch from '../../Hooks/useFetch'
import CareerApply from '../section-components/CareerApply/CareerApply'
import RegisterInterest from '../section-components/RegisterInterest/RegisterInterest'

// import Button from "@material-ui/core/Button";
// import CloudUploadIcon from "@material-ui/icons/CloudUpload";

// import { CircularProgress, Input } from "@material-ui/core";
// import Swal from "sweetalert2";

const Careers = () => {
  const { data } = useFetch()
  const myField = data?.items.find((item, index) => {
    if (item.sys.id === '2QuRoqsOEFf2PBBsItcuS4') {
      return item
    }
  })

  // console.log(myField?.fields)
  // console.log(baseUrl + data?.Pageheader.title.url)
  // const [loading, setloading] = React.useState(false);

  // const handleSendEmail = (e) => {
  //   setloading(true);
  //   try {
  //     setTimeout(() => {
  //       setloading(false);
  //       Swal.fire(
  //         "Email Sent!",
  //         "Your email is sent with your detail",
  //         "success"
  //       );
  //     }, 2000);
  //   } catch (err) {
  //     console.error(err);
  //     setloading(false);
  //   }
  // };

  return (
    <div>
      <Navbar />
      <PageHeader
        headertitle='Careers'
        Imagefile={myField?.fields.phTitle.fields.file.url}
      />

      <CareerApply />
      <RegisterInterest />
      {/* <div>
        <form
          className="contact-form-wrap contact-form-bg"
          style={{ boxShadow: "none" }}
        >
          <hr />
          <h4 className="text-center my-4 text-uppercase">Submit your CV</h4>

          <div className="rld-single-input">
            <input type="text" placeholder="FISRT NAME" />
          </div>
          <div className="rld-single-input">
            <input type="text" placeholder="LAST NAME" />
          </div>
          <div className="rld-single-input">
            <input type="text" placeholder="EMAIL" />
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="rld-single-input">
                <input type="text" placeholder="MOBILE PHONE" />
              </div>
            </div>
          </div>

          <input type="file" className="mt-4" placeholder="Upload" />

          {loading ? (
            <div className="d-flex justify-content-center mt-2">
              <CircularProgress />
            </div>
          ) : (
            <div className="btn-wrap text-right">
              <button
                onClick={(e) => handleSendEmail(e)}
                className="btn btn-yellow"
              >
                Submit
              </button>
            </div>
          )}
        </form>
      </div> 
    */}

      <Footer />
    </div>
  )
}

export default Careers
